import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';
// External libraries
import moment from 'moment';
// utils
import formatMoney from 'utils/formatMoney';

const CardStatement = ({ statement }) => {
  return (
    <div className="mb-0">
      <div className="py-1 py-lg-0 sh-auto sh-lg-4 border-bottom ">
        <Row className="g-0 h-100 align-content-center cursor-default">
          <Col xs="12" sm="6" lg="2" className="d-flex flex-column justify-content-center mb-2 mb-lg-0 order-1 order-lg-1 h-lg-100 position-relative">
            <div className="text-muted text-small d-lg-none">Concepto</div>
            <p className="p-0 pe-2 text-alternate h-100 d-flex align-items-center justify-content-center text-medium" style={{ lineHeight: 1 }}>{statement.statement_text.toUpperCase()}</p>
          </Col>
          <Col xs="12" sm="6" lg="2" className="d-flex flex-column justify-content-center align-items-lg-center mb-2 mb-lg-0 order-3 order-lg-2">
            <div className="text-muted text-small d-lg-none">Fecha movimiento</div>
            {/* ${statement.creation_date.slice(11, 19)} */}
            <div className="text-alternate d-flex justify-content-center text-medium">{`${moment(statement.created_date).format('DD-MM-YYYY')}`}</div>
          </Col>
          <Col xs="12" sm="6" lg="2" className="d-flex flex-column justify-content-center mb-2 mb-lg-0 order-4 order-lg-3">
            <div className="text-muted text-small d-lg-none">Referencia</div>
            <div className="text-alternate d-flex justify-content-center text-medium">{statement.reference}</div>
          </Col>
          <Col xs="12" sm="6" lg="3" className="d-flex flex-column justify-content-center ps-lg-4 mb-2 mb-lg-0 order-4 order-lg-3">
            <div className="text-muted text-small d-lg-none">Referencia Adicional</div>
            <div className="text-alternate d-flex justify-content-center text-medium">
              {statement.statement_text === 'Retorno Guia' && <span>{statement.reference_trace}</span>}
            </div>
          </Col>
          <Col
            xs="12"
            sm="8"
            lg="2"
            className="d-flex flex-column justify-content-center align-items-end  align-items-lg-start mb-2 mb-lg-0 order-last order-lg-5"
          >
            <div className="text-muted text-small d-lg-none">Monto</div>
            <span
              className={`text-alternative w-100 d-flex justify-content-center text-medium ${statement.statement_code === 'CDS' ||
                statement.statement_code === 'RGNU' ||
                statement.statement_code === 'DCI' ||
                statement.statement_code === 'RAL'
                ? 'text-success'
                : 'text-primary'
                }`}
            >
              <span className=" text-primary">$</span>
              {formatMoney(statement.amount)}
            </span>
          </Col>
          <Col
            xs="12"
            sm="4"
            lg="1"
            xxl="1"
            className="d-flex flex-column justify-content-center align-items-lg-end mb-2 mb-lg-0 order-2 text-end order-lg-last"
          >
            <div className="text-muted text-small d-lg-none ">SALDO</div>
            <span className="text-alternative text-alternate w-100 d-flex justify-content-center text-medium">
              <span className="text-alternate ">$</span>
              {formatMoney(statement.current_balance)}
            </span>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default CardStatement;
